const Badge = ({ children, variant = 'default', className = '' }) => {
  const styles = {
    default: 'bg-signal/10 text-steel border-signal/10',
    cyan: 'bg-cyan/10 text-cyan border-cyan/20',
    violet: 'bg-violet/10 text-violet border-violet/20',
    gold: 'bg-gold/10 text-gold border-gold/20',
    success: 'bg-success/10 text-success border-success/20',
    warning: 'bg-warning/10 text-warning border-warning/20',
    error: 'bg-error/10 text-error border-error/20',
  };

  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-[10px] font-mono font-medium tracking-wider uppercase border rounded ${styles[variant]} ${className}`}>
      {children}
    </span>
  );
};

export default Badge;
